import { AuthController } from '@/business/modules/auth';

const actions = {
	// TODO: Resolve circular dependency of AuthController
	/**
	 * Creates a new AuthController instance when called.
	 * This method is used to avoid circular dependency issues that would occur
	 * if we instantiated AuthController at the top of the file. By deferring
	 * the instantiation to method calls, we break the dependency chain that
	 * would form if AuthController has dependencies that eventually reference
	 * this store module.
	 */
	getInstance() {
		return new AuthController();
	},

	setPhoneNumber(phoneNumber) {
		this.phoneNumber = phoneNumber;
	},

	loginInit(phoneNumber) {
		return this.getInstance().loginInit(phoneNumber);
	},

	sendOtp(phoneNumber) {
		return this.getInstance().loginInit(phoneNumber);
	},

	loginAsAdmin(otpCode) {
		return this.getInstance().loginAsAdmin(otpCode);
	},

	verifyOtp(otp) {
		return this.getInstance().verifyOtp(otp);
	},

	signup(data) {
		return this.getInstance().signup(data);
	},

	updateUserInformation(payload) {
		return this.getInstance().updateUserInformation(payload);
	},

	getUserInformation() {
		return this.getInstance().getUserInformation();
	},

	loginByRefreshToken(token) {
		return this.getInstance().loginByRefreshToken(token);
	},
};

export default actions;
